import type { App } from 'vue'
import { init, captureException } from '@sentry/vue'

export default class ErrorHandler {
    private readonly enabled: boolean

    constructor(vueApp: App) {
        this.enabled = import.meta.env.VITE_SENTRY_ENABLED === '1'

        if (this.enabled) {
            init({
                app: vueApp,
                dsn: import.meta.env.VITE_SENTRY_DSN,
                sampleRate: 1.0,
                environment: import.meta.env.VITE_ENVIRONMENT,
                debug: false,
                normalizeDepth: 8,
                release: `ki_front_mode_${import.meta.env.MODE}_environment_${import.meta.env.VITE_ENVIRONMENT}_version_${APP_VERSION}`,
            })
        }
    }

    captureError(
        error: unknown,
        action: string,
        tags?: Record<string, string>,
        extras?: Record<string, unknown>,
    ) {
        if (!this.enabled) {
            if (import.meta.env.MODE === 'development') {
                console.log('___Capture error___')
                console.log({
                    action,
                    error,
                    tags,
                    extras,
                })
            }
            return
        }

        captureException(error, {
            tags: {
                action,
                ...tags,
            },
            extra: {
                extras,
            },
        })
    }
}
